<template>
  <van-row class="link-box">
    <van-col span="6" v-for="(a, i) in links" :key="i">
      <a
        :href="a.link + '?from=sxTxt-' + year"
        :style="'color:' + a.color"
        class="link"
        target="_blank"
        >{{ a.text }}</a
      >
    </van-col>
  </van-row>
</template>

<script>
import { mapState } from 'vuex'
export default {
  data() {
    return {
      links: [
        {
          link: 'https://suan.qxtky.com/show-2.html',
          text: '婚姻详批',
          color: '#F00'
        },
        {
          link: 'https://suan.qxtky.com/show-3.html',
          text: '测桃花运',
          color: '#e91e63'
        },
        {
          link: 'https://suan.qxtky.com/show-4.html',
          text: '八字算命',
          color: ''
        },
        {
          link: 'https://suan.qxtky.com/show-5.html',
          text: '流年预测',
          color: '#ff5722'
        },
        {
          link: 'http://cpa.bln8.com/caiyun/wap/',
          text: '财运专批',
          color: '#ff6d00'
        },
        {
          link: 'http://cpa.bln8.com/hunyin/wap/',
          text: '姻缘详批',
          color: '#e040fb'
        },
        {
          link: 'http://cpa.bln8.com/shiye/wap/',
          text: '事业专批',
          color: '#009688'
        },
        {
          link: 'http://cpa.bln8.com/zeri/wap/',
          text: '选择吉日',
          color: '#4caf50'
        }
      ]
    }
  },
  computed: {
    ...mapState(['year'])
  }
}
</script>

<style lang="scss" scoped>
.link {
  display: block;
  text-align: center;
  width: 100%;
  font-weight: bold;
  line-height: 32px;
}
</style>